angular.module('app.filters').filter('hdmiStandard', function() {
    const STD_480i60 = 3;
    const STD_480p60 = 4;
    const STD_576p50 = 5;
    const STD_720p30 = 6;
    const STD_720p50 = 7;
    const STD_720p60 = 8;
    const STD_1080i50 = 10;
    const STD_1080i60 = 11;
    const STD_1080p30 = 12;
    const STD_1080p50 = 13;
    const STD_1080p60 = 14;
    const STD_480p30 = 15;
    const STD_576p25 = 16;
    const STD_720p25 = 17;
    const STD_1080p25 = 18;

    // The following metadata ignored LCVS, just like the BoxCaster firmware does. Otherwise, these
    // represent Table 56 of http://www.analog.com/media/en/technical-documentation/user-guides/UG-214.pdf.
    const graphicsStandards = {
        svga: {
            [56]: { bl: 6508, lcf: 624, fcl: 1997 },
            [60]: { bl: 6039, lcf: 626, fcl: 1868 },
            [72]: { bl: 4756, lcf: 663, fcl: 1493 },
            [75]: { bl: 4878, lcf: 623.5, fcl: 1554 },
            [85]: { bl: 4259, lcf: 629.5, fcl: 1316 },
        },
        sxga: {
            [60]: { bl: 3571, lcf: 1064.5, fcl: 1868 },
        },
        vga: {
            [60]: { bl: 7272, lcf: 524, fcl: 1868 },
            [72]: { bl: 6042, lcf: 518.5, fcl: 1554 },
            [75]: { bl: 6098, lcf: 498.5, fcl: 1493 },
            [85]: { bl: 5286, lcf: 507.5, fcl: 1316 },
        },
        xga: {
            [60]: { bl: 4726, lcf: 803, fcl: 1868 },
            [70]: { bl: 4048, lcf: 803, fcl: 1598 },
            [75]: { bl: 3808, lcf: 798.5, fcl: 1493 },
            [85]: { bl: 3327, lcf: 806.5, fcl: 1316 },
        },
        // TODO: Figure out what the values are for SXGA75, WXGA, SXGA+, UXGA(R), and WSXGA(R)
    };

    // The tolerance we allow from the params above. Again, matches the BoxCaster firmware.
    const TOLERANCE = 0.01;

    return function(hdmi) {
        if (!hdmi.cable_detected) {
            return '';
        } else {
            switch (hdmi.standard) {
                case STD_480i60:
                    return '480i60';
                case STD_480p60:
                    return '480p60';
                case STD_576p50:
                    return '576p50';
                case STD_720p30:
                    return '720p30';
                case STD_720p50:
                    return '720p50';
                case STD_720p60:
                    return '720p60';
                case STD_1080i50:
                    return '1080i50';
                case STD_1080i60:
                    return '1080i60';
                case STD_1080p30:
                    return '1080p30';
                case STD_1080p50:
                    return '1080p50';
                case STD_1080p60:
                    return '1080p60';
                case STD_480p30:
                    return '480p30';
                case STD_576p25:
                    return '576p25';
                case STD_720p25:
                    return '720p25';
                case STD_1080p25:
                    return '1080p25';
                default:
                    if (!hdmi.interlaced) {
                        // Lookup graphics standard
                        for (let gstd of Object.keys(graphicsStandards || {})) {
                            const rates = graphicsStandards[gstd];
                            for (let frate of Object.keys(rates || {})) {
                                const params = rates[frate];
                                const [blMin, blMax] = [Math.floor(params.bl * (1 - TOLERANCE)), Math.ceil(params.bl * (1 + TOLERANCE))];
                                const [lcfMin, lcfMax] = [Math.floor(params.lcf * (1 - TOLERANCE)), Math.ceil(params.lcf * (1 + TOLERANCE))];
                                const [fclMin, fclMax] = [Math.floor(params.fcl * (1 - TOLERANCE)), Math.ceil(params.fcl * (1 + TOLERANCE))];
                                if ((hdmi.bl >= blMin) && (hdmi.bl <= blMax) && (hdmi.lcf >= lcfMin) && (hdmi.lcf <= lcfMax) && (hdmi.fcl >= fclMin) && (hdmi.fcl <= fclMax)) {
                                    return gstd.toUpperCase() + frate.toString();
                                }
                            }
                        }
                        return "None or unknown";
                    } else {
                        return "None or unknown";
                    }
            }
        }
    };
});


// WEBPACK FOOTER //
// ./filters/hdmi_standard.js